import React from 'react';
import { Section } from './ui/Section';
import { AlertTriangle, Droplets, ThermometerSun } from 'lucide-react';
export function ProblemSection() {
  return <Section background="white" className="border-t border-stone-100" data-id="element-348">
      <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-349">
        <span className="text-amber-600 font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-350">
          La Realidad
        </span>
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-stone-900 mb-6" data-id="element-351">
          Estuviste 4 horas en la cocina... para esto.
        </h2>
        <p className="text-lg text-stone-600 leading-relaxed" data-id="element-352">
          Cuidaste la crema, horneaste las capas con amor y el postre se veía
          increíble... pero para cuando llegaron tus invitadas y diste el primer
          corte, el hojaldre estaba blando, la crema se desparramó por los lados
          y el "crunch" había desaparecido.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8 mt-12" data-id="element-353">
        <div className="bg-stone-50 p-8 rounded-xl border border-stone-100 hover:shadow-md transition-shadow" data-id="element-354">
          <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mb-6" data-id="element-355">
            <AlertTriangle className="w-6 h-6 text-red-600" data-id="element-356" />
          </div>
          <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-357">
            El Síndrome del Hojaldre Chicloso
          </h3>
          <p className="text-stone-600" data-id="element-358">
            No es tu culpa. Las recetas de YouTube están diseñadas para comerse
            al instante, no para resistir una cena real.
          </p>
        </div>

        <div className="bg-stone-50 p-8 rounded-xl border border-stone-100 hover:shadow-md transition-shadow" data-id="element-359">
          <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-6" data-id="element-360">
            <Droplets className="w-6 h-6 text-blue-600" data-id="element-361" />
          </div>
          <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-362">
            Migración de Humedad
          </h3>
          <p className="text-stone-600" data-id="element-363">
            La crema pastelera es 70% agua. Sin protección, ese agua ataca tu
            hojaldre desde el segundo uno.
          </p>
        </div>

        <div className="bg-stone-50 p-8 rounded-xl border border-stone-100 hover:shadow-md transition-shadow" data-id="element-364">
          <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mb-6" data-id="element-365">
            <ThermometerSun className="w-6 h-6 text-amber-600" data-id="element-366" />
          </div>
          <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-367">
            El Enemigo Invisible
          </h3>
          <p className="text-stone-600" data-id="element-368">
            En Florida, Texas o New York, la humedad ambiental destruye el
            crujiente antes de que termines de montar.
          </p>
        </div>
      </div>
    </Section>;
}